import React from 'react';
import { LightModal, LightCloseButton } from '../light-ui';

interface CreditsInfoModalProps {
  open: boolean;
  onClose: () => void;
  balance: number | null;
  /** Archive interviews: credits go to Archive gifts, and nothing says Proxi. */
  isArchive?: boolean;
}

const CreditsInfoModal: React.FC<CreditsInfoModalProps> = ({ open, onClose, balance, isArchive }) => {
  const title = isArchive ? 'Credits' : 'Proxi Credits';
  return (
    <LightModal open={open} onClose={onClose} dismissable ariaLabel={`About ${title}`}>
      <LightCloseButton onClick={onClose} />
      <div className="lp-modal-body" style={{ textAlign: 'center' }}>
        <h2 className="lp-section-heading">{title}</h2>
        <p className="lp-prose" style={{ maxWidth: 420 }}>
          {isArchive
            ? 'You earn credits every time you answer a question in an interview. Use them to create Archive gifts.'
            : 'You earn credits every time you answer a question in an interview. Spend them to unlock full content in the circles you care about, and to explore more on Proxi.'}
        </p>
        {balance != null && (
          <p className="lp-prose" style={{ maxWidth: 420, fontWeight: 600 }}>
            You have {balance} credits.
          </p>
        )}
        <button
          type="button"
          className="lp-btn lp-btn-primary"
          style={{ marginTop: 8, minWidth: 200 }}
          onClick={onClose}
        >
          Got it
        </button>
      </div>
    </LightModal>
  );
};

export default CreditsInfoModal;
